import {
  CopyPasteBold,
  MessagesBubbleTyping1Bold,
  MessagingWhatsappBold,
  SocialMediaFacebookBold,
} from '@ha/icons';
import React from 'react';
import { useIntl } from 'ha/i18n';
import { makeStyles } from 'tss-react/mui';

import { ShareTargets } from 'ha/utils/socialShareURLs';

import { ListItemIcon, ListItemText, MenuItem, MenuList } from '@hbf/dsl';

const useStyles = makeStyles()({
  icon: {
    minWidth: '32px',
  },
});

interface Props {
  isMobile?: boolean;
  onShareTargetClicked: (target: ShareTargets) => void;
  shareTargets?: ShareTargets[];
}

const SocialShareMenu: React.FC<Props> = React.memo(
  ({
    isMobile = false,
    onShareTargetClicked,
    shareTargets = [
      ShareTargets.copy,
      ShareTargets.facebookSend,
      ShareTargets.facebook,
      ShareTargets.messenger,
      ShareTargets.whatsapp,
    ],
  }) => {
    const { T } = useIntl();
    const { classes } = useStyles();

    return (
      <MenuList data-test-locator="SocialShareMenu">
        {shareTargets.includes(ShareTargets.facebook) && (
          <MenuItem onClick={() => onShareTargetClicked(ShareTargets.facebook)}>
            <ListItemIcon className={classes.icon}>
              <SocialMediaFacebookBold fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={T('Facebook')} />
          </MenuItem>
        )}

        {shareTargets.includes(ShareTargets.whatsapp) && (
          <MenuItem onClick={() => onShareTargetClicked(ShareTargets.whatsapp)}>
            <ListItemIcon className={classes.icon}>
              <MessagingWhatsappBold fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={T('Whatsapp')} />
          </MenuItem>
        )}

        {(shareTargets.includes(ShareTargets.messenger) ||
          shareTargets.includes(ShareTargets.facebookSend)) && (
          <MenuItem
            onClick={() =>
              onShareTargetClicked(
                isMobile ? ShareTargets.messenger : ShareTargets.facebookSend,
              )
            }
          >
            <ListItemIcon className={classes.icon}>
              <MessagesBubbleTyping1Bold fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={T('Messenger')} />
          </MenuItem>
        )}

        {shareTargets.includes(ShareTargets.copy) && (
          <MenuItem onClick={() => onShareTargetClicked(ShareTargets.copy)}>
            <ListItemIcon className={classes.icon}>
              <CopyPasteBold fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={T('Copy link')} />
          </MenuItem>
        )}
      </MenuList>
    );
  },
);

export { SocialShareMenu };
